import { SelectionModel } from '@angular/cdk/collections';
import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PageEvent } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QMSPaginatorComponent } from 'src/app/shared/components/qms-paginator/qms-paginator.component';
import { SearchEmployeeFilter } from '../../../user/models/search-emplyee-filter';
import { EmployeeModel } from '../../../user/models/user-model';

@Component({
  selector: 'app-add-member-to-role',
  standalone: true,
  imports: [
    QMSPaginatorComponent,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    NgIf,
    NgFor,
    TranslateModule,
    RouterModule,
  ],
  templateUrl: './add-member-to-role.component.html',
  styleUrl: './add-member-to-role.component.scss',
})
export class AddMemberToRoleComponent {
  @Input() employees: EmployeeModel[] = [];
  @Input() totalEmployee!: number;
  @Output() searchEvent: EventEmitter<SearchEmployeeFilter> = new EventEmitter();
  @Output() onAddMemberEvent: EventEmitter<number[]> = new EventEmitter();

  displayedColumns: string[] = ['select', 'firstName', 'lastName', 'departmentName', 'username'];

  dataSource = new MatTableDataSource<EmployeeModel>();
  selection = new SelectionModel<EmployeeModel>(true, []);
  filter: SearchEmployeeFilter = new SearchEmployeeFilter();
  pageSizeOptions: number[] = [10, 25, 100];
  totalCount = 0;

  constructor(private dialogRef: MatDialogRef<AddMemberToRoleComponent>) {
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  onSearch(): void {
    this.searchEvent.emit(this.filter);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.onAddMemberEvent.emit(this.selection.selected.map((item) => item.id));
  }

  pageEvent(event: PageEvent) {
    this.filter.pageIndex = ++event.pageIndex;
    this.filter.pageSize = event.pageSize;
    this.searchEvent.emit(this.filter);
  }
}
